module.exports = __webpack_public_path__ + "static/media/03.ba5a5a35.JPG";